import { useState } from "react";
import { X } from "lucide-react";
import { site } from "@/content/liane-site.ar";
import { useReveal } from "@/hooks/use-reveal";
import g1 from "@/assets/liane/gallery-new-1.jpg.asset.json";
import g2 from "@/assets/liane/gallery-new-2.jpg.asset.json";
import g3 from "@/assets/liane/gallery-new-3.jpg.asset.json";
import g4 from "@/assets/liane/gallery-new-4.jpg.asset.json";
import g5 from "@/assets/liane/gallery-new-5.jpg.asset.json";
import sunflower from "@/assets/liane/gallery-5.jpg";

const images = [
  { src: g1.url, alt: "قطع صابون ليان يدوية بطبقات وردية وخضراء وزخارف نباتية", w: 958, h: 1280 },
  { src: g2.url, alt: "صندوق هدايا ليان الخشبي مع صابون طبيعي وشمعة عطرية", w: 949, h: 1280 },
  { src: g3.url, alt: "توزيعات ليان بلون النعناع مغلفة يدوياً بشرائط ساتان", w: 996, h: 1280 },
  { src: g4.url, alt: "صابون ليان بنفسجي منقوش مع أكياس قماش وردية", w: 968, h: 1280 },
  { src: g5.url, alt: "صابون زيت الزيتون وزبدة الشيا بأشكال زهور طبيعية", w: 1119, h: 1280 },
  { src: sunflower, alt: "صابون عبّاد الشمس الطبيعي المنقوش يدوياً", w: 800, h: 1000 },
];

export function Gallery() {
  const reveal = useReveal<HTMLDivElement>();
  const [active, setActive] = useState<number | null>(null);
  const activeImage = active === null ? undefined : images[active];

  return (
    <section id="gallery" className="py-16 lg:py-24">
      <div ref={reveal.ref} className={`container-liane ${reveal.className}`}>
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-2xl font-bold text-l-primary sm:text-3xl lg:text-4xl">
            {site.gallery.title}
          </h2>
          <p className="mt-4 text-base text-l-muted-foreground sm:text-lg">{site.gallery.sub}</p>
        </div>

        <div className="mt-10 columns-2 gap-4 lg:columns-3">
          {images.map((img, i) => (
            <button
              key={img.alt}
              type="button"
              onClick={() => setActive(i)}
              className="mb-4 block w-full overflow-hidden rounded-2xl border border-l-border bg-l-card shadow-l-soft transition-transform hover:scale-[1.01]"
            >
              <img
                src={img.src}
                alt={img.alt}
                width={img.w}
                height={img.h}
                loading="lazy"
                decoding="async"
                className="h-auto w-full object-cover"
              />
            </button>
          ))}
        </div>
      </div>

      {activeImage && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label={activeImage.alt}
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[60] flex items-center justify-center bg-l-foreground/80 p-4 backdrop-blur-sm"
        >
          <button
            type="button"
            aria-label={site.gallery.closeLabel}
            onClick={() => setActive(null)}
            className="absolute top-4 end-4 grid size-12 place-items-center rounded-full bg-l-card text-l-foreground"
          >
            <X className="size-5" />
          </button>
          <img
            src={activeImage.src}
            alt={activeImage.alt}
            width={activeImage.w}
            height={activeImage.h}
            className="max-h-[85vh] w-auto max-w-full rounded-2xl object-contain"
          />
        </div>
      )}
    </section>
  );
}
